<div class="skeleton-product-card-container">
	<div>
		<div class="hmf-m-xs skeleton-grey-loading-box big"></div>
		<div class="hmf-m-xs skeleton-grey-loading-box small"></div>
	</div>
	<div class="hmf-m-xs skeleton-grey-loading-box medium"></div>
</div>
